"use client";

/**
 * AuthExpiryRedirect — zero-render listener komponent koji hvata
 * `grozd:auth:unauthorized` event iz @grozd/sdk apiClient-a (dispatch-ovan
 * na prvom 401 odgovoru u sesiji) i redirect-uje korisnika na auth login
 * sa razlogom.
 *
 * Velibor 2026-05-04 incident: tab je ostao otvoren, JWT je istekao, pollers
 * su nastavili da kucaju API, svaki 401 izazivao je toast + retry → rate
 * limit lockout pri pokušaju reload-a/login-a.
 *
 * Sada: prvi 401 → ovaj listener uhvati event → odmah replace location na
 * auth login. Pollers prestaju (page unmount). UI ne spamuje toast-ovima.
 *
 * Single-fire flag je u apiClient-u (`__grozdAuthUnauthorizedDispatched`),
 * tako da paralelni 401-i NE pucaju paralelne redirect-e.
 *
 * Vidi docs/za-nas/2026-05-04-session-expiry-flood-analysis.md (Sloj 2).
 */

import * as React from "react";

const AUTH_URL =
  (typeof window !== "undefined"
    ? (window as any).__GROZD_AUTH_URL__
    : process.env.NEXT_PUBLIC_AUTH_URL) ||
  (typeof window !== "undefined" &&
  window.location.hostname.endsWith(".dev.grozd.me")
    ? "https://auth.dev.grozd.me"
    : "https://auth.grozd.me");

export function AuthExpiryRedirect(): null {
  React.useEffect(() => {
    function onUnauthorized(_e: Event) {
      try {
        sessionStorage.setItem(
          "grozd:auth:return_url",
          window.location.href
        );
      } catch {
        // private mode / quota — nije fatalno
      }
      const target = `${AUTH_URL}/login?reason=session_expired`;
      window.location.replace(target);
    }

    window.addEventListener("grozd:auth:unauthorized", onUnauthorized);
    return () => {
      window.removeEventListener(
        "grozd:auth:unauthorized",
        onUnauthorized
      );
    };
  }, []);

  return null;
}

export default AuthExpiryRedirect;
